import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();
export const userDataState = atom({
  key: "userDataState",
  default: { username: "", email: "", teamId: "", isLogged: false },
  effects_UNSTABLE: [persistAtom],
});
export const bearerToken = atom({
  key: "bearerToken",
  default: "",
  effects_UNSTABLE: [persistAtom]
});
export const isLoggedInState = atom({
  key: "isLoggedInState",
  default: false,
  effects_UNSTABLE: [persistAtom],
});
export const secSkillData = atom({
  key: "secSkillData",
  default: [],
  effects_UNSTABLE: [persistAtom],
});
export const priSkillData = atom({
  key: "priSkillData",
  default: [],
  effects_UNSTABLE: [persistAtom],
});
export const myTeamData = atom({
  key: "myTeamData",
  default: [],
  effects_UNSTABLE: [persistAtom],
});
export const mileStoneData = atom({
  key: "mileStoneData",
  default: [],
  effects_UNSTABLE: [persistAtom],
});
export const jobLevelCycle = atom({
  key: "jobLevelCycle",
  default: { jobLevel: "" },
  effects_UNSTABLE: [persistAtom],
});
export const jobUserData = atom({
  key: "jobUserData",
  default: {
    joinedLevel: 1,
    currentLevel: 8,
    currentlevelText: "L8",
    position: "Senior Software Engineer",
  },
  effects_UNSTABLE: [persistAtom],
});

export const currentJobLevel = atom({
  key: "currentJobLevel",
  default: "",
  effects_UNSTABLE: [persistAtom],
});

export const currentJobLevelData = atom({
  key: "currentJobLevelData",
  default: "",
  effects_UNSTABLE: [persistAtom],
});

export const careerWheelData = atom({
  key: "careerWheelData",
  default: "",
  effects_UNSTABLE: [persistAtom]
});
export const frmPage = atom({
  key: "frmPage",
  default: "dashboard",
  effects_UNSTABLE: [persistAtom]
});


export const certificateURL = atom({
  key: "certificateURL",
  default: "",
  effects_UNSTABLE: [persistAtom]
})
export const otherDiv = atom({
  key: "otherDiv",
  default: false,
  effects_UNSTABLE: [persistAtom]
})
export const logoutDrpdown = atom({
  key: "logoutDrpdown",
  default: false,
  effects_UNSTABLE: [persistAtom],
});